import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const PageHeader = props => (
  <div className="page-header">
    <div className="page-header-inner">
      <div className="page-header-content">
        <h1>
          {props.userFirstName && `${props.userFirstName}, `}
          Seja bem-vindo(a)!
        </h1>
        <p>
          A TTRUCK é uma plataforma de gestão produtiva e centralizada do fluxo operacional
          entre frota, motoristas e operadores, com enfoque na colaboração e comunicação ativa
        </p>

        {/* <div className="page-header-info">
          <span>
            Redux Boilerplate <br />Implemented
          </span>
        </div> */}
      </div>
    </div>
  </div>
);

PageHeader.propTypes = {
  userFirstName: PropTypes.string.isRequired,
};

export default connect(state => ({
  userFirstName: (!!state.authState.currentProfile && state.authState.currentProfile.firstName) || '',
}))(PageHeader);



// WEBPACK FOOTER //
// ./src/Shared/Helpers/PageHeader.js